import { DateTime } from "@/lib/dates"
import { useCurrentDate } from "./useCurrentDate"

export function useToday() {
	return DateTime.fromJSDate(useCurrentDate())
}
